
import Card from "@/components/base/card/Card"

import rules from "@/mixins/rules"
import { mdiClockOutline, mdiCalendarRange } from "@mdi/js"
import dates from "@/mixins/dates"

export default {
    name: "DateTimeCard",
    components: { Card },
    mixins: [rules, dates],
    props: {
        date: {
            type: [String],
            default: "",
        },
        time: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        mdiClockOutline,
        mdiCalendarRange,
        timeError: "",
        dateError: "",
    }),
    computed: {
        internalTime: {
            get() {
                return this.time
            },
            set(newTime) {
                this.$emit("update:time", newTime)
            },
        },
        internalDate: {
            get() {
                if (this.date instanceof Date) {
                    return this.date.toISOString().split("T")[0]
                } else if (this.date) {
                    return new Date(this.date).toISOString().split("T")[0]
                }
                return ""
            },
            set(newDate) {
                this.$emit("update:date", newDate)
            },
        },
    },
    methods: {
        validate() {
            let isValid = true
            let timeParts = this.time.split(":")
            let date = new Date()
            date.setHours(timeParts[0], timeParts[1], 0)
            if (!date > 0) {
                this.timeError = "Zeit fehlerhaft"
                isValid = false
            }
            if (!this.date) {
                this.dateError = "Dies ist ein Pflichtfeld"
                isValid = false
            }
            return isValid
        },
    },
}
